import React, { Component } from 'react';

import { postJson } from '../../helpers/RequestsHelper'

class Survey2 extends Component {

    state = {
        id: 1,
        localId: "",
        userId: "",
        completed: false,
        canContact: false,
        email: "",
        name: "",
        dodocument: "",
        wanttodocument: "",
        toolused: "",
        toolusedother: false,
        whodocuments: "",
        whodocumentsother: false,
        notespro: "",
        notescon: "",
        errors: ""
    }

    constructor() {
        super()
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    onSubmit = async (e) => {
        let body = this.state

        const cognitoUser = window.userPool.getCurrentUser()

        if (cognitoUser) {
            //This is done for open surveys
            body.userId = cognitoUser.username
        }

        if(this.validateForm()){
            this.setState({ completed: true })
            this.setState({errors: ""})
            await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/survey/result", body)
        }
    }

    onChange = (state) => {
        state.completed = false
        this.setState(state)
    }

    validateEmail(email) {
        if (!email) {
            return true
        }
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validateForm(){
        let formIsValid = true;

        if(this.state.dodocument == ""){
           formIsValid = false
        }

        if(this.state.wanttodocument == ""){
            formIsValid = false
        }

        if(this.state.toolused == ""){
            formIsValid = false
        }

        if(this.state.whodocuments == ""){
            formIsValid = false
        }

        if(this.state.notespro == ""){
            formIsValid = false
        }

        if(this.state.notescon == ""){
            formIsValid = false
        }

        this.setState({errors: "Please fill in all questions."})
        return formIsValid
    } 

    render() {
        return (
            <div>
                <h1>How do you document your processes at work? <i className="far fa-lightbulb" style={{ color: "#d01a62" }}></i></h1>
                <br />
                <h6>Please take this 1-minute survey to share your experience with documenting business processes at your team/company. 'Documenting' could be any process description or visualization like lists, diagrams, flowcharts, tree maps, timelines, etc. Thank you for your feedback!</h6>
                <div onChange={(e) => this.onChange({ dodocument: e.target.value })}>
                    Do you (or someone else from your team/company) document your processes?*<br />
                    <input type="radio" name="dodocument" value="yes" autoComplete="off" required /> Yes
                <br />
                    <input type="radio" name="dodocument" value="no" autoComplete="off" /> No
                <br />
                    <input type="radio" name="dodocument" value="noidea" autoComplete="off" /> No idea
                </div>
                <br />
                <div onChange={(e) => this.onChange({ wanttodocument: e.target.value })}>
                    Do you think it is helpful to have processes documented?*<br />
                    <input type="radio" name="wanttodocument" value="absolutely" autoComplete="off" required /> Absolutely
                <br />
                    <input type="radio" name="wanttodocument" value="somewhat" autoComplete="off" /> Somewhat
                <br />
                    <input type="radio" name="wanttodocument" value="rathernot" autoComplete="off" /> Rather not
                <br />
                    <input type="radio" name="wanttodocument" value="notatall" autoComplete="off" /> Not at all
                </div>
                <br />
                <div onChange={(e) => this.onChange({ toolused: e.target.value })}>
                    What software tool does your team/company primarily utilize for process documentation or visualization?*<br />
                    <input type="radio" name="toolused" value="visio" autoComplete="off" /> Visio
                <br />
                    <input type="radio" name="toolused" value="lucidchart" autoComplete="off" required /> Lucidchart
                <br />
                    <input type="radio" name="toolused" value="spreadsheets" autoComplete="off" /> Spreadsheets (Excel, Google Sheets)
                <br />
                    <input type="radio" name="toolused" value="notsoftware" autoComplete="off" /> Not a software tool (paper, whiteboard)
                <br />
                    <input type="radio" name="toolused" value="notool" autoComplete="off" /> No tool (it's institutional knowledge, people just know their stuff)
                <br />
                    <input type="radio" name="toolused" value="othertool" autoComplete="off" onChange={(e) => this.onChange({ toolusedother: e.target.checked })} /> Other
                    {this.state.toolusedother ?
                        <input className="form-control w-200"
                            type="text"
                            name="toolused"
                            autoComplete="name"
                            id="toolused"
                            onChange={(e) => this.onChange({ toolused: e.target.value })} />
                    : ""}
                </div>
                <br />
                <div onChange={(e) => this.onChange({ whodocuments: e.target.value })}>
                    Who is (or should be) in charge of documenting your team's processes?*<br />
                    <input type="radio" name="whodocuments" value="everyone" autoComplete="off" required /> Every team member does their own
                <br />
                    <input type="radio" name="whodocuments" value="manager" autoComplete="off" /> Team lead/manager
                <br />
                    <input type="radio" name="whodocuments" value="director" autoComplete="off" /> Director/higher-up
                <br />
                    <input type="radio" name="whodocuments" value="bizops" autoComplete="off" /> BizOps
                <br />
                    <input type="radio" name="whodocuments" value="otherdocument" autoComplete="off" onChange={(e) => this.onChange({ whodocumentsother: e.target.checked })} /> Other
                    {this.state.whodocumentsother ?
                        <input className="form-control w-200"
                            type="text"
                            name="whodocuments"
                            autoComplete="name"
                            id="whodocuments"
                            onChange={(e) => this.onChange({ whodocuments: e.target.value })} />
                    : ""}
                </div>
                <br />
                If you could think of the biggest benefit of documenting processes, what would that be?*
                <br />
                <textarea className="form-control w-400" onChange={(e) => this.onChange({ notespro: e.target.value })} required></textarea>
                <br />
                <br />
                What is the top reason people/companies don't bother documenting their processes?*
                <br />
                <textarea className="form-control w-400" onChange={(e) => this.onChange({ notescon: e.target.value })} required></textarea>
                <br />
                
                <br />

                <div className="custom-control custom-switch" >
                    <input type="checkbox" className="custom-control-input" id="switch" onChange={(e) => this.onChange({ canContact: e.target.checked })} />
                    <label className="custom-control-label" htmlFor="switch">Would it be OK for us to follow up with you?</label>
                </div>
                <br /><br />

                {this.state.canContact ?
                    <div>
                        Email address
                        <br />
                        {this.validateEmail(this.state.email) ? "" : <small id="errorMessage" className="text-danger">Please enter a valid email address</small>}
                        <input className="form-control w-400"
                            type="email"
                            name="email"
                            autoComplete="email"
                            id="email"
                            onChange={(e) => this.onChange({ email: e.target.value })} />
                        <br />
                        Name
                        <br />
                        <input className="form-control w-400"
                            type="text"
                            name="name"
                            autoComplete="name"
                            id="name"
                            onChange={(e) => this.onChange({ name: e.target.value })} />
                        <br />
                    </div>
                    : ""}

                {this.state.errors
                    ? <span className="text-danger"><b>{this.state.errors}</b></span>
                    : ""
                }
                
                <br />

                {this.state.completed
                    ? <span className="text-success"><b>Thanks a lot! Survey code: 104729</b></span>
                    : <button className="submit-btn" onClick={this.onSubmit}>Submit</button>
                }
                
                <br /><br />
                Would you like to <a href="https://simplyflows.com/">learn more</a> about us?
            </div>
        )
    }
}

export default Survey2;